<script lang="ts">
  let {
    detected = false,
    highlightIntensity = 0
  }: {
    detected?: boolean;
    highlightIntensity?: number;
  } = $props();

  const glowOpacity = $derived(detected ? Math.max(0.6, highlightIntensity * 0.9) : 0.35);
  const pulseClass = $derived(highlightIntensity > 0.5 ? 'pulse' : '');
</script>

<div class="ar-corner-brackets {pulseClass}" class:detected style="--glow-opacity: {glowOpacity}">
  <div class="ar-corner tl"></div>
  <div class="ar-corner tr"></div>
  <div class="ar-corner bl"></div>
  <div class="ar-corner br"></div>
</div>

<style>
  .ar-corner-brackets {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 15;
  }

  .ar-corner {
    position: absolute;
    width: 28px;
    height: 28px;
    opacity: var(--glow-opacity);
    transition: opacity 0.3s ease;
  }

  .ar-corner.tl {
    top: 16px;
    left: 16px;
    border-top: 2.5px solid #3b82f6;
    border-left: 2.5px solid #3b82f6;
    border-top-left-radius: 6px;
    box-shadow:
      -3px -3px 8px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.6)),
      inset 1px 1px 4px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.3));
  }

  .ar-corner.tr {
    top: 16px;
    right: 16px;
    border-top: 2.5px solid #3b82f6;
    border-right: 2.5px solid #3b82f6;
    border-top-right-radius: 6px;
    box-shadow:
      3px -3px 8px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.6)),
      inset -1px 1px 4px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.3));
  }

  .ar-corner.bl {
    bottom: 16px;
    left: 16px;
    border-bottom: 2.5px solid #3b82f6;
    border-left: 2.5px solid #3b82f6;
    border-bottom-left-radius: 6px;
    box-shadow:
      -3px 3px 8px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.6)),
      inset 1px -1px 4px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.3));
  }

  .ar-corner.br {
    bottom: 16px;
    right: 16px;
    border-bottom: 2.5px solid #3b82f6;
    border-right: 2.5px solid #3b82f6;
    border-bottom-right-radius: 6px;
    box-shadow:
      3px 3px 8px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.6)),
      inset -1px -1px 4px rgba(59, 130, 246, calc(var(--glow-opacity) * 0.3));
  }

  .detected .ar-corner {
    border-color: #60a5fa;
    background: radial-gradient(circle at var(--corner-x, 50%) var(--corner-y, 50%), rgba(96, 165, 250, 0.08), transparent 70%);
  }

  .detected .ar-corner.tl,
  .detected .ar-corner.tr {
    background: linear-gradient(135deg, rgba(96, 165, 250, 0.12), transparent 60%);
  }

  .detected .ar-corner.bl,
  .detected .ar-corner.br {
    background: linear-gradient(315deg, rgba(96, 165, 250, 0.12), transparent 60%);
  }

  .pulse {
    animation: bracketPulse 2s ease-in-out infinite;
  }

  @keyframes bracketPulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  .pulse .ar-corner {
    animation: cornerGlow 2s ease-in-out infinite;
  }

  @keyframes cornerGlow {
    0%, 100% {
      box-shadow:
        -3px -3px 8px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5)),
        0 0 12px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.25));
    }
    50% {
      box-shadow:
        -3px -3px 16px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.8)),
        0 0 24px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5));
    }
  }

  .pulse .ar-corner.tr {
    animation-name: cornerGlowTR;
  }

  @keyframes cornerGlowTR {
    0%, 100% {
      box-shadow:
        3px -3px 8px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5)),
        0 0 12px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.25));
    }
    50% {
      box-shadow:
        3px -3px 16px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.8)),
        0 0 24px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5));
    }
  }

  .pulse .ar-corner.bl {
    animation-name: cornerGlowBL;
  }

  @keyframes cornerGlowBL {
    0%, 100% {
      box-shadow:
        -3px 3px 8px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5)),
        0 0 12px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.25));
    }
    50% {
      box-shadow:
        -3px 3px 16px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.8)),
        0 0 24px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5));
    }
  }

  .pulse .ar-corner.br {
    animation-name: cornerGlowBR;
  }

  @keyframes cornerGlowBR {
    0%, 100% {
      box-shadow:
        3px 3px 8px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5)),
        0 0 12px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.25));
    }
    50% {
      box-shadow:
        3px 3px 16px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.8)),
        0 0 24px rgba(96, 165, 250, calc(var(--glow-opacity) * 0.5));
    }
  }
</style>